module.exports = __webpack_public_path__ + "img/10.32a0d467.png";